import { PUSH as PUSH_ERROR } from '../actions/errors';
import {
  PLACE_ORDER,
  START_CANCEL_TRANSACTION,
  END_CANCEL_TRANSACTION,
  START_WORLDPAY_MODAL,
  RECEIVE_PAYMENT_RESPONSE,
  ORDER_CREATED,
} from '../actions/transaction';

const initialState = {
  isCancelling: false,
  isInProgress: false,
};

const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case PUSH_ERROR:
      // [TODO]: Find out if there are error patterns we should ignore
      return state.isInProgress ? { ...state, isInProgress: false } : state;
    case PLACE_ORDER:
      return state.isInProgress ? state : { ...state, isInProgress: true };
    case RECEIVE_PAYMENT_RESPONSE:
      return state.isInProgress ? { ...state, isInProgress: false } : state;
    case ORDER_CREATED:
      return state.isInProgress ? { ...state, isInProgress: false } : state;
    case START_CANCEL_TRANSACTION:
      return {
        ...state,
        isCancelling: true,
        isInProgress: false,
      };
    case END_CANCEL_TRANSACTION:
      return initialState;
    case START_WORLDPAY_MODAL:
      // NOTE: Only needed for redux-observable side-effect
      return state;
    default:
      return state;
  }
};

export default transactionReducer;
